import { Stack, Typography } from '@mui/material'
import BaseWidgetProvider from './base/BaseWidgetProvider'
import { useMemo } from 'react'
import FontDownloadIcon from '@mui/icons-material/FontDownload'

const TextWidget = (props) => {
  const { data } = props
  const text = useMemo(() => {
    if (!data || !data.text) {
      return ''
    }
    return data.text.replace(/{{\s*([^}]+)\s*}}/g, (_, path) => {
      const keys = path.split('.')
      let value = props
      for (const key of keys) {
        value = value?.[key]
        if (value === undefined) return ''
      }
      return value
    })
  }, [props, data])

  return (
    <Stack
      sx={{ height: '100%' }}
      justifyContent='space-around'
      alignItems={data.align}
    >
      <Typography
        sx={{ fontSize: data?.fontSize }}
        color={data?.textColor}
      >
        {text}
      </Typography>
    </Stack>
  )
}

class TextWidgetProvider extends BaseWidgetProvider {
  getCode = () => 'TextWidgetProvider'

  getName = () => 'Text'

  getIcon = () => FontDownloadIcon

  createWidget = (props) => <TextWidget {...props} />

  createPreviewWidget = (props) => <TextWidget {...props} data={{ ...props.data, text: 'Text' }} />

  getWidgetInfo = (columns, cellHeight) => {
    return { ...super.getWidgetInfo(columns, cellHeight), availableWithoutDevice: true, hideHeader: true }
  }

  getConfigurationInfo = () => {
    return [
      {
        key: 'text',
        type: 'text',
        label: 'Text',
        defaultValue: '{{device.name}}'
      },
      {
        key: 'textColor',
        type: 'color',
        label: 'Text color',
        defaultValue: '#FFFFFF'
      },
      {
        key: 'fontSize',
        type: 'text',
        label: 'Font size',
        defaultValue: '1rem'
      },
      {
        key: 'align',
        type: 'select',
        label: 'Align',
        defaultValue: 'center',
        selectableOptions: ['start', 'center', 'end']
      }
    ]
  }
}

export default TextWidgetProvider
